import React from "react";
import { Helmet } from "react-helmet";
import SiteLayout from "components/layout/SiteLayout";
import Hero from "components/marketing/Hero";
import TrustBand from "components/marketing/TrustBand";
import ProofLoop from "components/marketing/ProofLoop";
import IntentRamps from "components/marketing/IntentRamps";
import PlatformStrip from "components/marketing/PlatformStrip";
import DeveloperSurface from "components/marketing/DeveloperSurface";
import IntegrationsRow from "components/marketing/IntegrationsRow";
import CommunityVelocity from "components/marketing/CommunityVelocity";
import { siteMeta, brandAssets } from "content/site";

export default function HomePage() {
	return (
		<>
			<Helmet>
				<title>{siteMeta.title}</title>
				<meta name="description" content={siteMeta.description} />
				<meta property="og:title" content={siteMeta.title} />
				<meta property="og:description" content={siteMeta.description} />
				<meta property="og:image" content={siteMeta.ogImage} />
				<link rel="icon" href={brandAssets.favicon} />
				<link rel="apple-touch-icon" href={brandAssets.icon92} />
			</Helmet>
			<SiteLayout>
				<Hero />
				<TrustBand />
				<ProofLoop />
				<PlatformStrip />
				<IntentRamps />
				<DeveloperSurface />
				<IntegrationsRow />
				<CommunityVelocity />
			</SiteLayout>
		</>
	);
}
